import { prop } from 'datx';
import { Picker } from './Picker';

import { BaseModel } from './BaseModel';

export class Feature extends BaseModel {
  public static type = 'feature';

  @prop
  public icon!: string;

  @prop
  public zIndex!: number;

  @prop.toMany(Picker)
  public pickers!: Array<Picker>;
}
